
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form4ProcessHeader from "@/components/process/Form4/components/Form4ProcessHeader.vue";
import { packageInfoType } from '@/types/Information';
import { form4DataInfoType, form4StatusInfoType } from '@/types/Information/Form4';
@Component({
    components:{
        Form4ProcessHeader
    }
})
export default class SuccessSubmitForm4 extends Vue {

    @Prop({required: true})
    packageInfo!: packageInfoType;

    stepsCompleted = {} as form4StatusInfoType;  
    mountedData = false; 

    form4Data = {} as form4DataInfoType;
    generalMessage = true;

    mounted() {
        this.mountedData = false;
        this.stepsCompleted = {
            first: true,
            second: true,
            third: true
        } 
        this.saveApplication(this.packageInfo);               
    }

    public saveApplication(newPackageInfo: packageInfoType) {

        const data = {
            packageNumber: newPackageInfo.packageNumber,
            packageUrl: newPackageInfo.eFilingUrl 
        } 

        const url = "/form4/efiling/"+newPackageInfo.fileNumber+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.put(url, data, header)
        .then(res => {                            
            this.getForm4Data(newPackageInfo.fileNumber);
        }, err => {
            console.error(err);
            this.mountedData = true;
        });    
    }    

    public getForm4Data(fileNumber) {        
       
        this.$http.get('/form4/forms/'+fileNumber)
        .then((response) => {
            if(response?.data?.data){            
                            
                this.form4Data = response.data.data
                console.log(this.form4Data)
                this.generalMessage = !this.form4Data.orderList.includes('payment of security')
                                        && !this.form4Data.orderList.includes('adducing fresh or new evidence')
                                        && !this.form4Data.orderList.includes('quashing an appeal or raising a preliminary objection')
                                        && !this.form4Data.orderList.includes('intervener status')
                                        && !this.form4Data.orderList.includes('varying or cancelling an order of the registrar');
                this.mountedData = true;                
                              
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
